import * as Sentry from '@sentry/browser'

import { saveEventOnAnalytics, identifyMachine, getLocalStorageItem, setLocalStorageItem, EventBus, setSessionStorageItem } from '../../../../utils/helpers'

import env from '../../../../config/environment'
import EmpresasService from '../../../../services/empresas'

class EfLayout extends AbstractController {
  static get $inject() {
    return ['$injector', '$state', '$scope', '$rootScope', '$uibModal', 'pathService', 'api', 'UsuariosService', 'Faturamento', 'gql', 'EfLockScreenService']
  }

  constructor($injector, $state, $scope, $rootScope, $uibModal, pathService, api, UsuariosService, Faturamento, gql, EfLockScreenService) {
    super($injector)

    this.UsuariosService = UsuariosService
    this.usuario = UsuariosService.usuarioLogado
    this.api = api
    this.modal = $uibModal
    this.$scope = $scope
    this.$state = $state
    this.gql = gql
    this.apply = (fun) => $scope.$applyAsync(fun)
    this.Faturamento = Faturamento
    this.EfLockScreenService = EfLockScreenService
    this.$rootScope = $rootScope

    window.usuario_id = this.usuario.id

    Sentry.setUser({
      id: this.usuario.id,
      username: this.usuario.nome,
      email: this.usuario.email,
    });

    if (env.logrocket) {
      this.api.get("/check-feature/record_logrocket_session").then(result => {
        if (result.data.enabled) {
          import('logrocket').then(LogRocket => {
            LogRocket.init(env.logrocket.dsn, env.logrocket.options)

            LogRocket.identify(this.usuario.id, {
              name: this.usuario.nome,
              email: this.usuario.email,
            });

            LogRocket.getSessionURL(sessionURL => {
              Sentry.configureScope(scope => {
                scope.setExtra("logrocket_session_url", sessionURL);
              });
            });
          })
        }
      })
    }

    this.api.get("/check-feature/integracao_vindi").then((result) =>
      this.isIntegracaoVindiEnabled = result.data.enabled
    )

    this.modalMeusDados = this.openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/modal-dados-usuario.html', 'dadosUsuarioModalController as ctrl', 'lg', 'static')
    this.modalTrocarSenha = this.openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/modal-trocar-senha.html', 'dadosUsuarioModalController as ctrl', 'md', 'static')
    this.modalConfigNotificacoes = this.openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/config-notificacoes-modal.html', 'configNotificacoesController as ctrl', 'lg')
    this.modalCertificadosVencidos = this.openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/certificados-vencidos-modal.html', 'certificadosVencidosModalController as ctrl', 'lg', 'static')
    this.modalCertificadoInexistente = this.openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/certificado-inexistente-modal.html', 'CertificadoInexistenteModalController as ctrl', 'lg', 'static')

    Promise
      .all([this.api.get(`/usuarios/${this.usuario.id}`)])
      .then(([userResult]) => {
        let insertedAt

        const usuario = userResult.data.usuario

        if (!usuario.password_has_been_changed)
          this.modalTrocarSenha({ userId: () => usuario.id }, () => location.reload())
        else
          insertedAt = new Date(usuario.inserted_at)

        window.Intercom("boot", {
          app_id: "kpnfyz9v",
          name: usuario.nome,
          email: usuario.email,
          admin_url: `https://app.eficienciafiscal.com.br/admin/usuarios/${usuario.id}`,
          created_at: parseInt(insertedAt.getTime() / 1000),
          user_hash: usuario.intercom_hash
        })
      });

    this.api.get("/certificados-vencidos").then((result) => {
      if (result.data.certificados.length > 0)
        this.modalCertificadosVencidos({ certificados: () => result.data.certificados })
    })

    this.api.get("/certificado-inexistente").then((result) => {
      if (result.data.empresas.length > 0)
        this.modalCertificadoInexistente({ empresas: () => result.data.empresas })
    })

    $scope.$on('empresaAdicionada', (_$event, id) => this.empresaAdicionada(id))
  }

  $onInit() {
    pageSetUp()
    this.loadEmpresas()
    this.loadFerramentasDisponiveis()
    EmpresasService.getAllFromUser()
  }

  addEmpresa() {
    this.modal
      .open({
        component: 'cadastrarContratoModal',
        size: 'lg',
        keyboard: 'static',
        resolver: {}
      })
      .result
      .then((result) => result && this.$scope.$root.$broadcast(env.empresa_add, result))
  }

  editarDados(id) {
    this.modalMeusDados({
      userId: () => id
    }, () => location.reload())
  }

  openContratosModal(id) {
    this.modal.open({
      component: 'contratosModal',
      size: 'xl',
      resolve: {
        usuarioId: id
      }
    })
  }

  showModalCertificados() {
    this.modal.open({
      size: 'lg',
      component: 'atualizarCertificadosModal'
    })
  }

  showColetores() {
    this.modal.open({
      size: 'lg',
      component: 'coletoresModal',
      keyboard: false
    })
  }

  configNotificacoes() {
    this.modalConfigNotificacoes({})
  }

  hasAdminRole() {
    return ["analista_tributario", "admin_ef", "admin"].includes(this.usuario.role)
  }

  logout() {
    this.UsuariosService.logout().then(() => this.$state.go('login'))
  }

  active(route) {
    return this.$state.includes(route)
  }

  empresaAdicionada(id) {
    this.loadEmpresas()
      .then(() => {
        const empresa = this.empresas.find(c => c.id == id)
        this.selectEmpresa(empresa)
      })
      .then(() => this.apply())
  }

  onSelectEmpresa() {
    this.selectEmpresa(this.empresaSelected)
  }

  showContainerEmpresa() {
    const urlsToNotShow = ['/configuracoes', '/contratos/:contratoId']
    return !urlsToNotShow.includes(this.$rootScope.currentURL) && this.empresas?.length > 0
  }

  async selectEmpresa(empresa) {
    empresa.id = parseInt(empresa.id)
    const query = gql`
      query CheckFeatureProdutosPorFilial {
        enabled: checkFeature(feature: "integracao_vindi", empresaId: ${empresa.id})
      }
    `

    try {
      const { enabled } = await this.gql.query(query)
      this.isFeatureIntegracaoVindiEnabled = enabled
      this.empresa = empresa
      this.empresaSelected = empresa

      setSessionStorageItem(env.selected_empresa, empresa)
      setLocalStorageItem(env.last_selected_empresa_id, empresa.id)
      saveEventOnAnalytics('EscolhaDeEmpresa', `${empresa.raizCnpj} | ${empresa.razaoSocial}`)

      const { id, raizCnpj, razaoSocial } = empresa
      window.currentEmpresa = { id, raizCnpj, razaoSocial }
      await this.loadFerramentasContratadas()
      await this.loadFiliais()

      EventBus.$emit(env.empresa_change, empresa.id)
      this.$scope.$root.$broadcast(env.empresa_change, empresa.id)
      this.apply()

    } catch (e) {
      console.log('error-select', e)
    }
  }

  loadEmpresas() {
    const query = gql`
      query EmpresasList {
        usuarioAtual {
          id
          nome
          email
          role
          permissoes {
            id
            admin
            empresa: partialEmpresa {
              id
              raizCnpj
              razaoSocial
              contrato(withCliente: false) {
                id
                diasAcessoRestantes
              }
            }
          }
        }
      }
    `

    return this.promise = this.gql
      .query(query)
      .then(({ usuarioAtual: { permissoes, ...usuario } }) => {
        window.currentUsuario = usuario
        this.usuario = usuario

        saveEventOnAnalytics('UsuariosQueMaisLogam', identifyMachine())

        this.empresas = permissoes
          .filter(({ empresa }) => empresa)
          .map(({ id, admin, empresa }) => {
            const { diasAcessoRestantes, ...contrato } = { ...empresa.contrato }

            return {
              ...empresa,
              id: parseInt(empresa.id),
              hasContrato: empresa.contrato ? true : false,
              contrato: {
                ...contrato,
                diasAcessoRestantes,
                inadimplente: diasAcessoRestantes && diasAcessoRestantes < 1
              },
              permissao: { id, admin }
            }
          })

        const lastSelectedId = getLocalStorageItem(env.last_selected_empresa_id)

        if (lastSelectedId) {
          const ultimaEmpresaSelecionada = this.empresas.find(empresa => empresa.id === lastSelectedId)

          if (ultimaEmpresaSelecionada) {
            this.empresaSelected = ultimaEmpresaSelecionada

            return this.selectEmpresa(ultimaEmpresaSelecionada)
          }
        }

        if (this.empresas.length === 1) {
          return this.selectEmpresa(this.empresas[0])
        }
      })
      .finally(() => this.apply())
  }

  loadFerramentasContratadas() {
    return this.UsuariosService
      .permissoes({ empresaId: parseInt(this.empresa.id) })
      .then(ferramentasContratadas => this.ferramentasContratadas = ferramentasContratadas)
  }

  loadFiliais() {
    return EmpresasService.getFiliais(this.empresa.id)
  }

  async loadFerramentasDisponiveis() {
    this.ferramentasDisponiveis = await this.Faturamento.listProdutos()

    this.ferramentasIdsByGrupo = this.ferramentasDisponiveis.groupBy(
      ferramenta => ferramenta.grupo || ferramenta.id,
      ferramenta => ferramenta.id
    )
  }

  openEmpresaModal() {
    this.modal
      .open({
        component: 'cadastrarFiliaisModal',
        size: 'xl',
        keyboard: 'static',
        resolve: {
          contratoId: () => this.empresa.id
        }
      })
      .result
      .then(result => {
        if (result) {
          this
            .loadEmpresas()
            .then(() => {
              this.empresa = this.empresas.find(c => c.id === this.empresa.id)
              this.empresaView = this.empresa
              this.tabs = []
            })
        }
      })
  }

  openUsuariosModal() {
    this.modal.open({
      component: 'contratoUsuarios',
      size: 'lg',
      keyboard: 'static',
      resolve: {
        contratoId: () => this.empresa.id,
        ferramentasDisponiveis: () => this.ferramentasDisponiveis
      }
    })
  }

  openConfiguracaoFaturamentoModal() {
    this.modal.open({
      component: 'configuracaoFaturamentoModal',
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
      resolve: {
        empresa: () => this.empresa,
        usuarioId: () => this.usuario.id
      }
    })
      .result
      .then(({ hasContrato, openContratosModal }) => {
        if (typeof (hasContrato) === "boolean") {
          this.empresa.hasContrato = hasContrato
        }

        if (openContratosModal) {
          this.modal.open({
            component: 'contratosModal',
            size: 'xl',
            keyboard: 'static',
            resolve: {
              usuarioId: () => this.usuario.id
            }
          })
        }
      })
  }

  enviarCertificado() {
    this.modal.open({
      component: 'envioCertificado',
      size: 'md',
      keyboard: 'static',
      resolve: {
        contrato: () => this.empresa
      }
    })
  }

  desvincularEmpresa() {
    Confirm.warning("Atenção!", "Deseja realmente desvincular seu usuário desta empresa?", {
      'Não': angular.noop,
      'Sim': () => {
        const mutation = gql`
          mutation DesvincularUsuario {
            permissao: deletePermissao(permissaoId: ${this.empresa.permissao.id}) {
              id
            }
          }
        `

        this.gql.mutate(mutation, {})
          .then(() => {
            this.apply(() => {
              Alert.success('O usuário foi desvinculado com sucesso.', 'Sucesso!')
              location.reload()
            })
          })
          .catch(([{ message }]) => {
            if (message === 'last_admin') {
              Alert.warning('A empresa precisa de pelo menos 1 usuário administrador.', 'Operação inválida!')
            }
          })
      }
    })
  }

  openEtiquetasModal() {
    this.modal
      .open({
        component: 'gerenciamentoEtiquetasModal',
        size: 'lg',
        keyboard: 'static',
        resolve: {
          empresaId: () => this.empresa.id
        }
      })
  }

  hasAcessoConfiguracoes() {
    return !this.isFeatureIntegracaoVindiEnabled
      || !this.empresa.hasContrato
      || !this.empresa.contrato.inadimplente
  }
}

angular.module('eficienciaFiscalModule').component('efLayout', {
  controller: EfLayout,
  template: `
    <div id="contentScreen" style="transition: 500ms" ng-cloak>
      <header class="header">
        <a href="/" id="logo-group">
          <img src="https://res.cloudinary.com/eficienciafiscal/image/upload/f_auto,fl_progressive,q_auto/v1588013281/app/logo-menu.png" alt="Logo Eficiência Fiscal" width="155" height="35">
        </a>

          <div class="header__options">

          <a target="_blank" href="https://intercom.help/eficiencia-fiscal/pt-BR" title="Dicas e respostas da Equipe Eficiência Fiscal">
            <i style="font-size: 22px; padding-top:2px;" class="fa fa-question-circle"></i>
          </a>

          <ef-notificacoes usuario-id="$ctrl.usuario.id" /></ef-notificacoes>

          <button class="btn btn-default navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </button>

          <a class="cursor-pointer hidden-xs" ng-click="$ctrl.addEmpresa()">
            <i class="fa fa-plus"></i>
            <strong>Adicionar empresa</strong>
          </a>

          <div class="dropdown cursor-pointer hidden-xs">
            <a id="drop-down-user" data-toggle="dropdown">
              <strong>{{ $ctrl.usuario.nome }}</strong>
              <i class="fa fa-user" aria-hidden="true"></i>
            </a>

            <ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="drop-down-user">
              <li>
                <a class="cursor-pointer" ng-click="$ctrl.editarDados($ctrl.usuario.id)">
                  <i class="fa fa-user"></i>
                  Meus dados
                </a>
              </li>
              <li>
                <a class="cursor-pointer" ng-click="$ctrl.configNotificacoes()">
                  <i class="fa fa-bell"></i>
                  Notificações
                </a>
              </li>
              <li class="divider"></li>
              <li>
                <a class="cursor-pointer" ng-click="$ctrl.showColetores()">
                  <i class="fa fa-desktop"></i>
                  Coletores
                </a>
              </li>
              <li>
                <a class="cursor-pointer" ng-click="$ctrl.showModalCertificados()">
                  <i class="fa fa-certificate"></i>
                  Certificados A1
                </a>
              </li>
              <li class="divider"></li>
              <li>
                <a href="javascript:void(0)" ng-click="$ctrl.logout()">
                  <i class="fa fa-sign-out fa-lg"></i>
                  <strong>Sair</strong>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </header>

      <div class="collapse navbar-collapse">
        <ul class="nav navbar-nav" ng-if="$ctrl.hasAdminRole()">
          <li ng-if="$ctrl.isIntegracaoVindiEnabled" ng-class="{active: $ctrl.active('layout.contratos')}">
            <a ui-sref="layout.contratos({contratoId: null})">
              <i class="fa fa-lg fa-fw fa-credit-card"></i>
              <span class="menu-item-parent">Contratos</span>
            </a>
          </li>
          <li ng-if="$ctrl.hasAdminRole()" ng-class="{active: $ctrl.active('layout.configuracoes')}">
            <a ui-sref="layout.configuracoes">
              <i class="fa fa-lg fa-fw fa-cogs"></i>
              <span class="menu-item-parent">Configurações</span>
            </a>
          </li>
          <li ng-class="{active: $ctrl.active('layout.dashboard')}">
            <a ui-sref="layout.dashboard">
              <i class="fa fa-lg fa-fw fa-home"></i>
              <span class="menu-item-parent">Ferramentas</span>
            </a>
          </li>
          <!-- <li ng-class="{active: $ctrl.active('layout.arquivosDigitais')}">
             <a ui-sref="layout.arquivosDigitais">
               <i class="fa fa-lg fa-fw fa-file-text"></i>
               <span class="menu-item-parent">Arquivos Digitais</span>
             </a>
           </li>-->
          <li ng-class="{active: $ctrl.active('layout.businessIntelligence')}" ng-if="$ctrl.ferramentasContratadas.includes('business-intelligence')">
            <a ui-sref="layout.businessIntelligence">
              <i class="fa fa-line-chart"></i>
              <span class="menu-item-parent">Business Intelligence</span>
            </a>
          </li>
        </ul>
      </div>

      <main id="content">
        <div id="loading-top" class="alert alert-load-system text-center">
          <i class='fa fa-circle-o-notch fa-spin'></i><span></span>
        </div>

        <h4 ng-if="$ctrl.empresas.length == 0" class="no-padding text-primary text-center-middle">
          Seu usuário ainda não possui empresas cadastradas. <a ng-click="$ctrl.addEmpresa()" class="cursor-pointer text-bold">Clique aqui</a> para começar...
        </h4>

        <div ng-if="$ctrl.showContainerEmpresa()" class="container_empresa">
          <span class="container_empresa__titulo">Empresa</span>

          <div class="select-empresa">
            <ui-select
              theme="bootstrap"
              name="empresa"
              ng-model="$ctrl.empresaSelected"
              ng-change="$ctrl.onSelectEmpresa()"
              required>
              <ui-select-match placeholder="Clique aqui para selecionar uma empresa.">
                {{ $select.selected.razaoSocial }} - Raiz do CNPJ: {{ $select.selected.raizCnpj | cpfCnpj }}
              </ui-select-match>
              <ui-select-choices repeat="empresa in $ctrl.empresas | filter: $select.search">
                <div>{{::empresa.razaoSocial}} - Raiz do CNPJ: {{ empresa.raizCnpj | cpfCnpj }}</div>
              </ui-select-choices>
            </ui-select>
          </div>

          <div class="dropdown">
            <button class="btn btn-default dropdown-toggle" type="button" id="drop-down-configuracoes" data-toggle="dropdown">
              <span class="hidden-xs">Configurações<span class="caret"></span></span>
              <i class="fa fa-cogs hidden-lg"></i>
            </button>

            <ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="drop-down-configuracoes">
              <li ng-show="$ctrl.isFeatureIntegracaoVindiEnabled && $ctrl.empresa.permissao.admin">
                <a ng-click="$ctrl.openConfiguracaoFaturamentoModal()">Faturamento</a>
              </li>
              <li ng-show="$ctrl.isFeatureIntegracaoVindiEnabled && $ctrl.empresa.permissao.admin" class="divider"></li>
              <li ng-show="$ctrl.hasAcessoConfiguracoes() && $ctrl.empresa.permissao.admin">
                <a ng-click="$ctrl.openUsuariosModal()">Usuários</a>
              </li>
              <li ng-show="$ctrl.hasAcessoConfiguracoes() && $ctrl.empresa.permissao.admin && $ctrl.usuario.role !== 'consultor' ">
                <a ng-click="$ctrl.openEmpresaModal()">Filiais</a>
              </li>
              <li ng-show="$ctrl.hasAcessoConfiguracoes()">
                <a ng-click="$ctrl.enviarCertificado()">Certificado A1</a>
              </li>
              <li ng-show="$ctrl.hasAcessoConfiguracoes() && $ctrl.empresa.permissao.admin">
                <a ng-click="$ctrl.openEtiquetasModal()">Etiquetas</a>
              </li>
              <li class="divider"></li>
              <li>
                <a ng-click="$ctrl.desvincularEmpresa()">Me desvincular desta empresa</a>
              </li>
              <li>
                <a target="_blank"
                  href="http://sac.eficienciafiscal.com.br/sac-servico-de-atendimento-ao-consumidor/?sac-razao-social-empresa={{$ctrl.empresa.razaoSocial.replace('&', '%26')}}&your-name={{$ctrl.usuario.nome}}&your-email={{$ctrl.usuario.email}}&sac-cnpj-empresa={{$ctrl.empresa.raizCnpj | cpfCnpj}}">
                  SAC
                </a>
              </li>
            </ul>
          </div>

        </div>

        <ui-view></ui-view>
      </main>

      <ef-lock-screen></ef-lock-screen>
    </div>
  `
})
